export default function () {
    return {
        totals: [],
    }
}
  